export class TrackingEvent {
  name: string;
  properties: EventProperties;
  constructor(opt?: Partial<TrackingEvent>) {
    Object.assign(this, opt);
  }
}

export interface EventProperties {
  href?: string;
  label?: string;
  componentId?: string;
  currentRoute?: string;
  query?: string;
}
